<template>
  <v-theme-provider :dark="dark">
    <div>
      <base-info-card
        :title="title"
        color="primary"
      >
        <slot />
      </base-info-card>

      <template v-for="({ icon, text, title: t }, i) in business">
        <base-avatar-card
          :key="i"
          :icon="icon"
          :outlined="false"
          :title="!dense ? t : undefined"
          color="transparent"
          horizontal
          space="0"
        >
          <!-- Do not use v-html for user -->
          <!-- provided values -->
          <div v-html="text" />
        </base-avatar-card>

        <v-divider
          v-if="i + 1 !== business.length"
          :key="`divider-${i}`"
          class="my-2"
        />
      </template>
    </div>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'BaseBusinessContact',

    props: {
      dark: Boolean,
      dense: Boolean,
      title: String,
    },

    data: () => ({
      business: [
        {
          icon: 'mdi-map-marker-outline',
          title: 'Adresse',
          text: '67/69, avenue Pierre Mendès-France, 75013 Paris',
        },
        // {
        //   icon: 'mdi-cellphone',
        //   title: 'Téléphone',
        //   text: '+ 33 1 xxxx',
        // },
        {
          icon: 'mdi-card-account-details',
          title: 'Directeur de la publication',
          text: 'Alain FRACHON, Président',
        },
      ],
    }),
  }
</script>
